'use strict';

window.isGfore = true;

window.jQuery = window.$ = require('jquery');
var processInclude = require('brand_core/util');
var slickSlider = require('brand_core/thirdParty/slickSlider');

$(function () {
    processInclude(require('brand_core/customDropdown'));
    processInclude(require('brand_core/components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('brand_core/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('brand_core/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('brand_core/components/toolTip'));
    processInclude(require('brand_core/components/header'));
    processInclude(require('brand_core/components/stickyFilter'));
    processInclude(require('brand_core/components/floatingLabel'));
    processInclude(require('brand_core/components/cookieNotification'));
    processInclude(require('brand_core/components/segmentedControl'));
    processInclude(require('brand_core/accessibility'));
    processInclude(require('brand_core/components/plpFaqAccordion'));
    processInclude(require('./global/productTile'));
    processInclude(require('brand_core/loqate'));
    processInclude(require('./productTile'));

    // Set up global accessibility for all slick carousels
    function setupAllCarousels() {
        var $carousels = $('.slick-initialized');

        $carousels.each(function () {
            slickSlider.setupAccessibility($(this));
        });
    }

    // Set up existing carousels after delays
    setTimeout(setupAllCarousels, 1000);
    setTimeout(setupAllCarousels, 2000);

    // Set up carousels after AJAX content loads
    $('body').on('product:afterAttributeSelect', function () {
        setTimeout(setupAllCarousels, 200);
    });
    $('body').on('cart:update', function () {
        setTimeout(setupAllCarousels, 200);
    });
    $('body').on('initRecommendationSlider', function () {
        setTimeout(setupAllCarousels, 200);
    });

    // Use MutationObserver to detect when new carousels are added
    // and when the chat launcher iframe is injected
    var observer = new MutationObserver(function (mutations) {
        setTimeout(setupAllCarousels, 100);

        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    var launcher = node.id === 'launcher' ? node : node.querySelector('#launcher');
                    if (launcher && launcher.tagName === 'IFRAME') {
                        launcher.title = 'Button to launch messaging window for customer care support';
                    }
                }
            });
        });
    });

    // Observe the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

require('brand_core/thirdParty/jquery.unveil.min');
require('brand_core/thirdParty/bootstrap');
require('base/components/spinner');
require('slick-carousel/slick/slick.js');
